import { render } from "./DividendCalendar.vue?vue&type=template&id=a86d1a74&scoped=true"
import script from "./DividendCalendar.vue?vue&type=script&lang=js"
export * from "./DividendCalendar.vue?vue&type=script&lang=js"

import "./DividendCalendar.vue?vue&type=style&index=0&id=a86d1a74&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a86d1a74"]])

export default __exports__